/** 
 * Author: Dhevanesam R
 * Crated Date: 01/18/2022
*/
import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';

class ItemHoldsStore extends EventEmitter {
    PageLoad = "";
    Search = "";
    PutOnHold = "";
    Update = "";
    Insertfav = "";
    deletefav = "";
    Notifyfav = "";
    workorderresponse = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleHoldItemsList = (action) => {

        switch (action.action.type) {
            case "PageLoad": {
                this.PageLoad = action.action.response;
                this.emit('PageLoad');
                break;
            }
            case "Search": {
                this.Search = action.action.response;
                this.emit('Search');
                break;
            }
            case "PutOnHold": {
                this.PutOnHold = action.action.response;
                this.emit('PutOnHold');
                break;
            }
            case "Update": {
                this.Update = action.action.response;
                this.emit('Update');
                break;
            }
            case "IH_InsertFavPage": {
                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "IH_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "IH_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            case "workordercheck": {
                this.workorderresponse = action.action.response;
                this.emit('workordercheck');
                break;
            }
            case "workorderfail": {
                this.workorderresponse = "fail";
                this.emit('WOfail');
                break;
            }
        }
    }
}
const objItemHoldsStore = new ItemHoldsStore;
// Dispatcher code
Dispatcher.register(objItemHoldsStore.handleHoldItemsList.bind(objItemHoldsStore));
export default objItemHoldsStore;